import React from "react";
import "./DownloadAPP.scss";
import http from "../../util/api";
import qs from "qs";
import { setItem, getItem } from "../../util/util";
import { Toast, Icon } from "antd-mobile";
import QRCode from "qrcode.react";
import pointPNG from "./point.png";

const baseURL = window.downloadAppBaseUrl;
const resid = "642788995190";
function getMobile() {
  let u = navigator.userAgent;
  let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; // g
  let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); // ios终端
  if (isAndroid) {
    return "Android";
  }
  if (isIOS) {
    return "IOS";
  }
}
function is_weixn() {
  let ua = navigator.userAgent.toLowerCase();
  if (ua.indexOf("micromessenger") > -1) {
    return true;
  } else {
    return false;
  }
}
function is_PC() {
  let userAgentInfo = navigator.userAgent;
  let Agents = [
    "Android",
    "iPhone",
    "SymbianOS",
    "Windows Phone",
    "iPad",
    "iPod",
  ];
  let flag = true;
  for (let v = 0; v < Agents.length; v++) {
    if (userAgentInfo.indexOf(Agents[v]) > 0) {
      flag = false;
      break;
    }
  }
  return flag;
}

const system = getMobile();
const isWX = is_weixn();
const isPC = is_PC();

// alert(system + "--isWx:" + isWX);

class DownloadAPP extends React.Component {
  state = {
    invitecode: "",
    appInfo: {},
    loading: true,
    hasApp: true,
  };

  async componentDidMount() {
    const search = document.location.search;
    const querystring = search.substring(1);
    const { appId, invitecode } = qs.parse(querystring);
    if (invitecode) {
      this.setState({ invitecode });
    }
    if (appId) {
      Toast.loading("", 0);
      await this.login();
      await this.getAppInfo(appId);
      Toast.hide();
      this.setState({ loading: false });
    } else {
      document.title = "未找到相关应用";
      this.setState({ hasApp: false, loading: false });
    }
  }

  login = async () => {
    try {
      const res = await http({
        baseURL,
      }).login({
        Code: "accountapp ",
        Password: "abc@1234",
      });
      console.log(res.data);
      const result = res.data.OpResult;
      if (result === "Y") {
        setItem("userInfo", JSON.stringify(res.data));
      }
    } catch (err) {
      this.setState({ loading: false });
      return console.error(err.message);
    }
  };
  getAppInfo = async (appid) => {
    try {
      const res = await http({ baseURL }).getTable({
        resid,
        cmswhere: `appId = '${appid}'`,
      });
      if (res.data.data.length) {
        const data = res.data.data[0];
        this.setState({ appInfo: data });
        document.title = data.title;
      } else {
        document.title = "未找到相关应用";
        this.setState({ hasApp: false });
      }
    } catch (error) {
      console.log(error);
    }
  };
  _mask = (
    <div className="android-mask">
      <div style={{ display: "flex" }}>
        <p
          style={{
            color: "#ffffff",
            flex: 1,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: 18,
            textShadow: "0px 0px 15px rgba(0, 0, 0, 0.33)",
          }}
        >
          请您点击右上角在浏览器中查看
        </p>
        <img
          src={pointPNG}
          style={{ height: "60px", width: "auto", marginRight: 8 }}
        />
      </div>
    </div>
  );
  render() {
    const { loading, appInfo, invitecode, hasApp } = this.state;
    if (loading) {
      return null;
    }
    if (!hasApp) {
      return (
        <div
          style={{
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            background: "#ffffff",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexDirection: "column",
            }}
          >
            <Icon type="cross-circle-o" color="#e83c4a" size="lg" />
            <p style={{ marginTop: 16, fontSize: 16 }}>未找到相关应用</p>
          </div>
        </div>
      );
    }
    if (isPC) {
      return (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <div style={{ width: 750, height: "auto" }}>
            {this.renderPCContent(appInfo, invitecode)}
          </div>
        </div>
      );
    }
    return appInfo.imgOrder === "last" ? (
      <div className="download-app">
        {this.renderMobileContent(appInfo, invitecode)}
        <img src={appInfo.img} style={{ width: "100%", height: "auto" }} />
        {system === "Android" && isWX && this._mask}
      </div>
    ) : (
      <div className="download-app">
        <img src={appInfo.img} style={{ width: "100%", height: "auto" }} />
        {this.renderMobileContent(appInfo, invitecode)}
        {system === "Android" && isWX && this._mask}
      </div>
    );
  }
  renderPCContent = (appInfo, invitecode) => {
    return (
      <div className="download-app">
        {appInfo.imgOrder === "first" && (
          <img src={appInfo.img} style={{ width: "100%", height: "auto" }} />
        )}
        <div
          className="app-text-introduction"
          style={{ background: appInfo.background, color: appInfo.color }}
        >
          <div className="app-name">{appInfo.appName}</div>
          <div className="app-discription">{appInfo.discription}</div>
          <div className="download-tip">扫描二维码立即下载应用</div>
          <div
            className="qr-code-wrapper"
            style={{ justifyContent: "space-around" }}
          >
            <div className="qr-code-container">
              <QRCode value={appInfo.linkIOS} size={window.innerWidth * 0.15} />
              <p style={{ fontSize: 30, color: "#000000", marginTop: 12 }}>
                苹果
              </p>
            </div>
            <div className="qr-code-container">
              <QRCode
                value={appInfo.linkAndroid}
                size={window.innerWidth * 0.15}
              />
              <p style={{ fontSize: 30, color: "#000000", marginTop: 12 }}>
                安卓
              </p>
            </div>
          </div>
          {invitecode && (
            <div style={{ fontSize: "4.27vw", padding: "1.8vh" }}>
              邀请码:{invitecode}
            </div>
          )}
        </div>
        {appInfo.imgOrder === "last" && (
          <img src={appInfo.img} style={{ width: "100%", height: "auto" }} />
        )}
      </div>
    );
  };
  renderMobileContent = (appInfo, invitecode) => {
    return (
      <div
        className="app-text-introduction"
        style={{ background: appInfo.background, color: appInfo.color }}
      >
        <div className="app-name">{appInfo.appName}</div>
        <div className="app-discription">{appInfo.discription}</div>
        <div className="download-tip">扫描或点击二维码立即下载应用</div>
        <div className="qr-code-wrapper">
          <div
            className="qr-code-container"
            onClick={() => {
              if (system === "IOS") {
                window.location.href = appInfo.linkIOS;
              } else if (system === "Android") {
                window.open(appInfo.linkAndroid);
              }
            }}
          >
            <QRCode
              value={system === "IOS" ? appInfo.linkIOS : appInfo.linkAndroid}
              size={window.innerWidth * 0.3013}
            />
          </div>
        </div>
        {invitecode && (
          <div style={{ fontSize: "4.27vw", padding: "1.8vh 0" }}>
            邀请码:{invitecode}
          </div>
        )}
      </div>
    );
  };
}

export default DownloadAPP;
